import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppContextType } from "./AppContextProvider";

export interface AppContextState {
    context: AppContextType
}

export const initialAppContextState: AppContextState = {
    context: {} as AppContextType
}

const appContextSlice = createSlice({

    name: 'appContext',

    initialState: initialAppContextState,

    reducers: {

        setAppContext(state: AppContextState, action: PayloadAction<AppContextType>) {
            state.context = action.payload
        },
        setLanguage(state: AppContextState, action: PayloadAction<"fr" | "en">){
            state.context.language = action.payload
        }
    }
})

export const {
    setAppContext,
    setLanguage
} = appContextSlice.actions
  
export const appContextReducer = appContextSlice.reducer